import { useState, useEffect, useRef, useMemo } from "react";
import { MathUtils } from "three";
import * as THREE from "three";
import { useFrame, useThree } from "@react-three/fiber";
import { useTimer } from "use-timer";
import gsap from "gsap";
import SceneOne from "./Background-scene/SceneOne";
import { getRenderer } from "./WebGLRendererSingleton";

const LevelTwo = ({
  // worldPosition,
  letter,
  letterImg,
  objectImg,
  nameImg,
  name,
  music,
  wordMusic,
  setConfetti,
  Yay,
  halfY,
  nextClick,
  setNextClick,
  wordCount,
}) => {
  const ref = useRef();
  const [spriteScale, setSpriteScale] = useState([0, 0, 0]);
  const [letterScale, setLetterScale] = useState([0, 0, 0]);
  const [intersectedObj, setIntersectedObj] = useState([]);
  const [extraState, setExtraState] = useState(0);

  const [worldPosition, setWorldPosition] = useState();

  const [click, setClick] = useState("");

  const [clickCurrent, setClickCurrent] = useState(undefined);
  const { time, start, pause, reset, status } = useTimer();
  // const { camera, gl } = useThree();
  const width = window.innerWidth;
  const height = window.innerHeight;
  const aspect = width / height;

  const fov = 50;
  const planeAspectRatio = 16 / 9;

  const viewSize = 50;
  var camera = new THREE.OrthographicCamera();
  camera.aspect = width / height;

  // var renderer = new THREE.WebGLRenderer();

  var timeOut;
  // Set the mesh positions

  const map = new THREE.TextureLoader().load(letterImg);

  const loader = new THREE.TextureLoader();
  // A png with transparency to use as the target sprite.
  // const textureA = loader.load(letterImg);

  const textureA = useMemo(
    () =>
      loader.load(letterImg, function (data) {
        // the rest of your code here...
        textureA.colorSpace = THREE.SRGBColorSpace;
        textureA.minFilter = THREE.LinearFilter;

        // textureA.wrapS = textureA.wrapT = THREE.RepeatWrapping;
        var tex = textureA.clone();

        tex.needsUpdate = true;
      }),
    [letterImg]
  );

  const objectTexture = useMemo(
    () =>
      loader.load(objectImg, function (data) {
        // the rest of your code here...
        objectTexture.colorSpace = THREE.SRGBColorSpace;
        objectTexture.minFilter = THREE.LinearFilter;

        // objectTexture.wrapS = textureA.wrapT = THREE.RepeatWrapping;
        var tex = objectTexture.clone();

        tex.needsUpdate = true;
      }),
    [objectImg]
  );
  const nameTexture = useMemo(
    () =>
      loader.load(nameImg, function (data) {
        // the rest of your code here...
        nameTexture.colorSpace = THREE.SRGBColorSpace;
        nameTexture.minFilter = THREE.LinearFilter;

        // objectTexture.wrapS = textureA.wrapT = THREE.RepeatWrapping;
        var tex = nameTexture.clone();

        tex.needsUpdate = true;
      }),
    [nameImg]
  );

  const clickHandTexture = useMemo(
    () => loader.load("ASSETS/HandPrompt.webp"),
    []
  );
  clickHandTexture.colorSpace = THREE.SRGBColorSpace;
  clickHandTexture.minFilter = THREE.LinearFilter;

  const raycaster = new THREE.Raycaster();
  const mouse = new THREE.Vector2();

  const { viewport: v, gl, scene } = useThree();

  var listener = new THREE.AudioListener();
  listener.autoplay = true;

  camera.add(listener);
  var sound = new THREE.Audio(listener);
  sound.autoplay = true;

  var audioLoader = new THREE.AudioLoader();
  audioLoader.autoplay = true;



  function useAspect(width, height, factor = 0.12) {
    const adaptedHeight =
      height * (aspect > width / height ? v.width / width : v.height / height);
    const adaptedWidth =
      width * (aspect > width / height ? v.width / width : v.height / height);
    return [adaptedWidth * factor, adaptedHeight * factor, 1];
  }

  const [aspectWidth, aspectHeight] = useAspect(
    window.innerWidth,
    window.innerHeight
  );

  const [renderers, setrenderers] = useState([]);

  function createRenderer() {
    if (renderers.length === 0) {
      const rendererr = getRenderer();

      setrenderers((prev) => [...prev, rendererr]);
      return rendererr;
    }
  }

  let renderer;
  if (renderers.length === 0) {
    renderer = createRenderer();
  }

  renderer?.domElement?.addEventListener("webglcontextlost", (event) => {
    console.log("WebGL context lost", gl.info.memory);

    textureA.dispose();
    objectTexture.dispose();
    objectTexture.dispose();
    clearTexture();
    setTimeout(() => {
      renderer?.forceContextRestore();
    }, 1000);
    // Handle context lost situation here
  });

  // Listen for context restored event
  renderer?.domElement?.addEventListener("webglcontextrestored", (event) => {
    console.log(" WebGL context restored");

    // Resources should be reloaded or recreated here
  });

  // Function to create a new WebGLRenderer instance

  useEffect(() => {
    adjustSpriteSize();
    setConfetti({ run: false, ratio: 0 });
    window.addEventListener("resize", function (e) {
      adjustSpriteSize();

      const height = window.innerHeight;
      const aspect = width / height;
      camera.aspect = window.innerWidth / window.innerHeight;

      if (camera.aspect > planeAspectRatio) {
        // window too large
        const cameraHeight = Math.tan(MathUtils.degToRad(fov / 2));
        const ratio = camera.aspect / planeAspectRatio;
        const newCameraHeight = cameraHeight / ratio;
        camera.fov = MathUtils.radToDeg(Math.atan(newCameraHeight)) * 2;
      } else {
        // window too narrow
        camera.fov = fov;
      }
      camera.updateProjectionMatrix();
      visibleWidthAtZDepth(camera.fov, camera);

      renderer?.setSize(width, height);
    });
    return () => {
      objectTexture.dispose();
      nameTexture.dispose();
      textureA.dispose();
      scene.traverse(function (child) {
        if (child instanceof THREE.Mesh) {
          child.geometry.dispose();
          // if(child?.material) {
          //   child.material.dispose();
          // }
        }
        if (child instanceof THREE.Sprite) {
          child.geometry.dispose();
          // if(child?.material) {
          //   child.material.dispose();
          // }
        }
        if (child instanceof THREE.Group) {
          // child.traverse(function (nestedChild) {
          //   nestedChild.geometry.dispose();
          //   nestedChild.material.dispose();
          // })
        }
      });
      if (renderer) {
        renderer?.dispose();
      }
    };
    // LeftRighBack()
  }, []);

  useEffect(() => {
    if (letter) {
      console.log("gl old", gl.info.memory);
      // renderer?.forceContextLoss();
      // renderer?.dispose();
      setTimeout(function () {
        // renderer?.forceContextRestore();
        console.log("gl new", gl.info.memory);
      }, 2000);
      ref.current.children[0].visible = false;
      ref.current.children[1].visible = false;
      ref.current.children[2].visible = false;
      ref.current.children[3].visible = false;
      gsap.to(ref.current.children[1].position, {
        y: 4,
      });
      gsap.to(ref.current.children[2].position, {
        y: 4,
      });
      gsap.to(ref.current.children[1].position, {
        y: 5,
        z: 1,
      });
      gsap.to(ref.current.children[2].position, {
        y: 5,
        z: 1,
      });

      gsap.to(ref.current.children[3].position, {
        z: 0,
      });
      setClick("");
      setEffectActive(undefined);
      setClickCurrent(undefined);
      setExtraState(0);
      setTimeout(() => {
        console.log("webgl", gl.info.memory);
        if (worldPosition) {
          console.log("CONTEXT memory", gl.info.memory);

          arrangeObj();
        }
      }, 1000);
    }

    return () => {
      clearTimeout(timeOut);
    };
  }, [letter, worldPosition]); // worldPosition

  const [effectActive, setEffectActive] = useState(undefined);
  const [effectActiveFor2, setEffectActiveFor2] = useState(undefined);

  useFrame(({ clock, state }) => {
    if (effectActive || effectActiveFor2) {
      const elapsedTime = clock.getElapsedTime();
      // Sine wave for continuous squash and stretch effect
      const scaleFactor = Math.sin(elapsedTime * 2) * 0.5 + 1.7;
      const stretchFactor = 1 / scaleFactor;
      // Apply squash and stretch by scaling on different axes
      //ref.current.children[0].scale.set(stretchFactor, scaleFactor, stretchFactor);
      ref.current.children[0].scale.x = stretchFactor;
      ref.current.children[0].scale.y = stretchFactor;
    } else {
      ref.current.children[0].scale.set(aspectWidth, aspectWidth, 1);
    }
  });

  const clearTexture = () => {
    scene.traverse(function (child) {
      if (child instanceof THREE.Mesh) {
        child.geometry.dispose();
      }
      if (child instanceof THREE.Sprite) {
        child.geometry.dispose();
      }
      if (child instanceof THREE.Group) {
        child.traverse(function (nestedChild) {
          // if (nestedChild instanceof THREE.Mesh) {
          //   nestedChild.geometry.dispose();
          //   nestedChild.material.dispose();
          // }
          // if (nestedChild instanceof THREE.Sprite) {
          //   nestedChild.geometry.dispose();
          //   nestedChild.material.dispose();
          // }
        });
      }
    });
    // renderer?.forceContextLoss();
    // setTimeout(function () {
    //   renderer?.forceContextRestore();
    // }, 200);
  };

  function adjustSpriteSize() {
    // Get the screen dimensions
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    // Define a base size for the sprite
    const baseWidth = 550; // Adjust this value as needed
    const baseHeight = 550; // Adjust this value as needed

    // Calculate the scale factors
    const scaleX = screenWidth / baseWidth;
    const scaleY = screenHeight / baseHeight;

    setSpriteScale([scaleX, scaleY, 0]);
    setLetterScale([scaleX, scaleY, 0]);
    // if(scaleX-(aspect/2) > 0.5 && scaleY-(aspect/2) > 0.5) {
    //   setLetterScale([scaleX-(aspect/2), scaleY-(aspect/2), 0])
    // } else {
    //   setLetterScale([0.5, 0.5, 0])
    // }
  }

  // create a global audio source

 

  function audioPlay(musicTrack) {
    if (sound.isPlaying) {
      sound.stop();
      sound.pause();
    }
    //Load a sound and set it as the Audio object's buffer
    audioLoader.load(`${musicTrack}`, function (buffer) {
      sound.setBuffer(buffer);
      sound.autoplay = true;

      sound.stop();
      sound.setLoop(false);
      sound.setVolume(1);
      sound.play();

      setTimeout(() => {
        sound.stop();
      }, buffer.duration * 1000);
    });
  }

  const visibleHeightAtZDepth = (depth, camera) => {
    // compensate for cameras not positioned at z=0
    const cameraOffset = camera.position.z;
    if (depth < cameraOffset) depth -= cameraOffset;
    else depth += cameraOffset;

    // vertical fov in radians
    const vFOV = (camera.fov * Math.PI) / 180;

    // Math.abs to ensure the result is always positive
    return 2 * Math.tan(vFOV / 2) * Math.abs(depth);
  };

  const visibleWidthAtZDepth = (depth, camera) => {
    const height = visibleHeightAtZDepth(depth, camera);

    return height * camera.aspect;
  };

  const [enableClick, setEnableClick] = useState(false);

  function onMouseClick(event, name) {
    if (sound.isPlaying) {
      sound.stop();
      sound.pause();
    }
    if (enableClick) {
      
      const object = ref.current.children[2];
      const objectName = ref.current.children[1];
      const alphabet = ref.current.children[0];
      // Calculate mouse position in normalized device coordinates (-1 to +1)
      mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
      mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
      // Update the picking ray with the camera and mouse position
      // raycaster.setFromCamera(mouse, camera);

      // // Calculate objects intersecting the picking ray
      // working rightly
      var vector = new THREE.Vector3(
        (event.clientX / window.innerWidth) * 2 - 1,
        -(event.clientY / window.innerHeight) * 2 + 1,
        0.5
      );
      var raycasterr = new THREE.Raycaster(
        camera.position,
        vector.sub(camera.position).normalize()
      );
      raycasterr.setFromCamera(vector, camera);

      // alternative
      var intersectss = intersectedObj?.filter((itm) => itm.name === name);
      for (let i = 0; i < intersectss.length; i++) {
        const intersectedObject = intersectedObj[i];
        ref.current.children[2].visible = true;
        let tempClicked = false;
        if (effectActive) {
          setClick("second");
        } else if (effectActive === undefined) {
          setClick("first");
        }
        // clickCurrent = true

        // setTimeout(() => {
        pause();
        setEffectActive(false);
        setClickCurrent(true);
        tempClicked = true;
        document.body.style.cursor = "pointer";
      }
    }
  }

  useEffect(() => {
    if (ref.current.children?.length > 0 && worldPosition && letter) {
      const object = ref.current.children[2];
      const objectName = ref.current.children[1];
      const alphabet = ref.current.children[0];
      const clickHand = ref.current.children[3];
      const positionLeft = worldPosition?.left;
      const positionRight = worldPosition?.right;

      let decimalPlaces = 4;
      if ((effectActive === undefined || !effectActive) && click === "first") {
        setEnableClick(false);
        pause();
        setEffectActive(false);
        const positionRight = worldPosition.right;

        if (
          object.position.y.toFixed(decimalPlaces) !==
          (positionRight.y + aspectWidth / 2).toFixed(decimalPlaces)
        ) {
          gsap.fromTo(
            object.position,
            {
              y: 5,
              x: positionRight?.x + aspect / 3.5,
            },
            {
              y: positionRight.y + aspectWidth / 2, //ref.current.children[2].scale.y, //1,
              x: positionRight.x + aspect / 3.5,
              // y: positionRight.y + aspectWidth * 1,
              // x: positionRight.x - aspectWidth / 4.7,
              z: 1,
              duration: 1,
              onComplete: () => {
                timeOut = setTimeout(() => {
                  objectName.visible = true;
                  ref.current.children[1].visible = true;
                  gsap.to(ref.current.children[1].position, {
                    x: positionRight?.x + aspect / 3.5, // - aspect / 2.5,
                    y: positionRight?.y - aspectWidth / 2,
                    z: 1,
                    duration: 0.5,
                    onComplete: () => {
                      if (clickCurrent !== false) {
                        setTimeout(() => {
                          audioPlay(wordMusic);
                          setTimeout(() => {
                            audioPlay(Yay);
                            setConfetti({ run: true, ratio: 1 });
                            gsap.to(alphabet.position, {
                              y: -4,
                              duration: 2,
                              delay: 6,
                            });
                            gsap.to(ref.current.children[1].position, {
                              y: -4,
                              duration: 1.5,
                              delay: 6,
                            });
                            gsap.to(object.position, {
                              y: -4,
                              duration: 2,
                              delay: 6,
                              onComplete: () => {
                                setTimeout(() => {
                                  if (nextClick < 2) {
                                    if (renderer) {
                                      renderer?.dispose();
                                    }
                                    objectTexture.dispose();
                                    nameTexture.dispose();
                                    textureA.dispose();
                                    setNextClick(nextClick + 1);
                                  } else if (nextClick === 2) {
                                    if (renderer) {
                                      renderer?.dispose();
                                    }
                                    objectTexture.dispose();
                                    nameTexture.dispose();
                                    textureA.dispose();
                                    clearTexture();
                                  }
                                }, 2000);
                              },
                            });
                          }, 3000);
                        }, 2000);
                      }
                    },
                  });
                }, 2000);
              },
            }
          );
        }
      } else if (!effectActive && click === "second") {
        setEnableClick(false);
        // object.visible = true;
        setClickCurrent(false);
        //if(object.position.y.toFixed(decimalPlaces) !== (positionRight.y + aspectWidth / 2).toFixed(decimalPlaces)) {
        gsap.fromTo(
          object.position,
          {
            y: 5,
            x: positionRight?.x + aspect / 3.5,
          },
          {
            y: positionRight.y + aspectWidth / 2, //ref.current.children[2].scale.y, //1,
            x: positionRight.x + aspect / 3.5,
            // y: positionRight.y + aspectWidth * 1, //ref.current.children[2].scale.y, //1,
            // x: positionRight.x - aspectWidth / 4.7,
            z: 1,
            duration: 1,
            onComplete: () => {
              setEffectActiveFor2(true);
              timeOut = setTimeout(() => {
                setEffectActiveFor2(false);
                objectName.visible = true;
                gsap.to(objectName.position, {
                  x: positionRight?.x + aspect / 3.5, // - aspect / 2.5,
                  y: positionRight?.y - aspectWidth / 2,
                  // y: -ref.current.children[1].scale.y,
                  z: 1,
                  delay: 1,
                  onComplete: () => {
                    audioPlay(music);
                    setTimeout(() => {
                      audioPlay(wordMusic);

                      setTimeout(() => {
                        clearTexture();

                        if (nextClick < 2) {
                          if (renderer) {
                            renderer?.dispose();
                          }
                          objectTexture.dispose();
                          nameTexture.dispose();
                          textureA.dispose();
                          setNextClick(nextClick + 1);
                        } else if (nextClick === 2) {
                          if (renderer) {
                            renderer?.dispose();
                          }
                          clearTexture();
                          objectTexture.dispose();
                          nameTexture.dispose();
                          textureA.dispose();
                        }
                      }, 2000);
                    }, 2000);

                    if (!clickCurrent) {
                    }
                  },
                });
              }, 2500);
            },
          }
        );
        //}
      } else if (
        !effectActive &&
        effectActive !== undefined &&
        click === "none"
      ) {
        setEnableClick(false);
        object.visible = true;
        setClickCurrent(false);

        gsap.fromTo(
          object.position,
          {
            y: 5,
            x: positionRight?.x + aspect / 3.5,
            // y: 4,
          },
          {
            y: positionRight.y + aspectWidth / 2, //ref.current.children[2].scale.y, //1,
            x: positionRight.x + aspect / 3.5,
            // y: positionRight.y + aspectWidth * 1, //ref.current.children[2].scale.y, //1,
            // x: positionRight.x - aspectWidth / 4.7,
            z: 1,
            duration: 1,
            onComplete: () => {
              timeOut = setTimeout(() => {
                objectName.visible = true;
                gsap.to(objectName.position, {
                  x: positionRight?.x + aspect / 3.5, // - aspect / 2.5,
                  y: positionRight?.y - aspectWidth / 2,
                  // y: -ref.current.children[1].scale.y,
                  z: 1,
                  delay: 3,
                  onComplete: () => {
                    audioPlay(music);
                    setTimeout(() => {
                      // audioPlay(wordMusic);
                    }, 2000);
                    if (!clickCurrent) {
                      clickHand.visible = true;
                      gsap.fromTo(
                        clickHand.position,
                        {
                          x: positionLeft?.x - aspect,
                          y: -1,
                          z: 2,
                        },
                        {
                          x: positionLeft?.x + aspect / 1.1,
                          y: -0.5,
                          z: 2.2,
                          delay: 4,
                          onComplete: () => {
                            setTimeout(() => {
                              gsap.to(clickHand.position, {
                                x: positionLeft?.x + aspect / 1.1,
                                y: -0.5,
                                z: 2,
                                duration: 0.5,
                                onComplete: () => {
                                  // audioPlay(music);
                                  setTimeout(() => {
                                    audioPlay(wordMusic);
                                  }, 1000);
                                  gsap.to(clickHand.position, {
                                    x: positionLeft?.x + aspect / 1.1,
                                    y: -0.5,
                                    z: 2.2,
                                    onComplete: () => {
                                      gsap.to(clickHand.position, {
                                        x: positionLeft?.x - aspect,
                                        y: -1,
                                        z: 2,
                                        duration: 1,
                                      });
                                      gsap.to(alphabet.position, {
                                        y: -4,
                                        duration: 2,
                                        delay: 4,
                                      });
                                      gsap.to(objectName.position, {
                                        y: -4,
                                        duration: 1.5,
                                        delay: 4,
                                      });
                                      gsap.to(object.position, {
                                        y: -4,
                                        duration: 2,
                                        delay: 4,
                                        onComplete: () => {
                                          setTimeout(() => {
                                            clearTexture();

                                            if (nextClick < 2) {
                                              if (renderer) {
                                                renderer?.dispose();
                                              }
                                              objectTexture.dispose();
                                              nameTexture.dispose();
                                              textureA.dispose();
                                              setNextClick(nextClick + 1);
                                            } else if (nextClick === 2) {
                                              if (renderer) {
                                                renderer?.dispose();
                                              }
                                              objectTexture.dispose();
                                              nameTexture.dispose();
                                              textureA.dispose();
                                              clearTexture();
                                            }
                                          }, 2000);
                                        },
                                      });
                                    },
                                  });
                                },
                              });
                            }, 1000);
                          },
                        }
                      );
                    }
                  },
                });
              }, 2000);
            },
          }
        );
      }
    }
  }, [click, effectActive]);

  useEffect(() => {
    if (clickCurrent === undefined) {
      // setEffectActive(false);
      // pause();
      // setClickCurrent(false);
      // setClick("none");
    } else {
      // pause()
      // setEffectActive(false)
    }
  }, [extraState]);

  useEffect(() => {
    const timer = setTimeout(() => {
      // Perform actions after waiting for 3 seconds
      if (letter && ref.current.children?.length > 0) {
        if (clickCurrent === undefined) {
          setEffectActive(true);
          start();
          // renderer?.forceContextLoss();
          // setTimeout(function () {
          //   renderer?.forceContextRestore();
          // }, 200);
          setTimeout(() => {
            setExtraState(1);
            setEffectActive(false);
            pause();
            setEnableClick(false);
            setClickCurrent(false);
            setClick("none");
          }, 3000);
        }
      }
    }, 8000);

    return () => clearTimeout(timer);
  }, [clickCurrent, letter]);

  function arrangeObj() {
    setConfetti({ run: false, ratio: 0 });

    const object = ref.current.children[2];
    const name = ref.current.children[1];
    const alphabet = ref.current.children[0];
    const clickHand = ref.current.children[3];
    ref.current.children[0].visible = true;
    ref.current.children[2].visible = false;
    ref.current.children[1].visible = false;
    ref.current.children[3].visible = false;

    const positionLeft = worldPosition.left;
    const positionRight = worldPosition.right;
    clickHand.visible = false;
    gsap.to(clickHand.position, {
      x: positionLeft?.x - aspect,
      y: -1,
    });

    // letter
    gsap.fromTo(
      alphabet.position,
      {
        y: 4, // 4,
        x: positionLeft?.x + aspectWidth / 2,
        z: 1,
      },
      {
        y: 0,
        x: positionLeft?.x + aspect / 3 + 0.15,
        duration: 2,
        onComplete: () => {
          audioPlay(music);
          setEnableClick(true);
          setTimeout(() => {
            setEffectActive(true);

            setTimeout(() => {
              setEffectActive(false);
              if (letter === "T" || letter === "Tr") {
                gsap.to(ref.current.children[2].scale, {
                  x: aspectWidth * 1.5,
                  y: aspectWidth * 1.5,
                  z: 1,
                });
              } else {
                gsap.to(ref.current.children[2].scale, {
                  x: aspectWidth,
                  y: aspectWidth,
                  z: 1,
                });
              }
            }, 6000);
          }, 2000);
        },
      }
    );
    setIntersectedObj([ref.current.children[0]]);
  }

  return (
    <>
      <SceneOne level={2} setWorldPosition={setWorldPosition} />
      <group ref={ref} dispose={null}>
        <mesh
          onClick={(e) => {
            onMouseClick(e, letter);
          }}
          scale={[aspectWidth / 1.5, aspectWidth / 1.5, 1]}
          name={letter}
        >
          <sprite isSprite={true}>
            <spriteMaterial
              attach="material"
              map={textureA}
              precision={"lowp"}
            />
          </sprite>
        </mesh>

        <mesh
          scale={[
            wordCount === 3
              ? aspectWidth * 0.9
              : wordCount === 4
              ? aspect * 1.1
              : wordCount === 5
              ? aspectWidth * 1.3
              : wordCount === 6
              ? aspectWidth * 1.6
              : wordCount === 7
              ? aspectWidth * 2
              : wordCount === 8
              ? aspectWidth * 2.1
              : wordCount === 9
              ? aspectWidth * 2
              : wordCount === 10
              ? aspectWidth * 2.1
              : aspectWidth,
            wordCount === 3
              ? aspectWidth * 0.9
              : wordCount === 4
              ? aspect * 1.1
              : wordCount === 5
              ? aspectWidth * 1.3
              : wordCount === 6
              ? aspectWidth * 1.6
              : wordCount === 7
              ? aspectWidth * 2
              : wordCount === 8
              ? aspectWidth * 2.1
              : wordCount === 9
              ? aspectWidth * 2
              : wordCount === 10
              ? aspectWidth * 2.1
              : aspectWidth,
            1,
          ]}
        >
          <sprite isSprite={true}>
            <spriteMaterial
              attach="material"
              map={nameTexture}
              precision={"lowp"}
            />
          </sprite>
        </mesh>

        <mesh scale={[aspectWidth, aspectWidth, 1]}>
          <sprite isSprite={true}>
            <spriteMaterial
              attach="material"
              map={objectTexture}
              precision={"lowp"}
            />
          </sprite>
        </mesh>
        {/* <mesh>
        <Html>
          {objectGifVisible && (
            <img
              src={objectImg}
              width={aspectWidth * 150}
              height={aspectWidth * 150}
            />
          )}
        </Html>
      </mesh> */}

        <mesh
          // scale={[
          //   spriteScale[0] / 1.6,
          //   spriteScale[1] / 1.4,
          //   spriteScale[2] / 1.6,
          // ]}
          scale={[aspectWidth / 1.5, aspectWidth / 1.5, 1]}
          visible={false}
        >
          <sprite>
            <spriteMaterial
              attach="material"
              map={clickHandTexture}
              precision={"lowp"}
            />
          </sprite>
        </mesh>
      </group>
    </>
  );
};

export default LevelTwo;
